<template>
  <div>
    <div v-if="centered" class="d-flex justify-content-center">
      <div class="spinner-border" role="status"></div>
    </div>

    <div v-if="!centered">
      <div class="spinner-border" role="status"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Spinner",
  props: {
    centered: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
